
import DisableableButton from '@/components/buttons/DisableableButton.vue';
import mediaFormFeatures from '@/mixins/mediaFormFeatures';
import RichTextInput from '../../components/RichTextInput.vue';

export default {
  components: { DisableableButton, RichTextInput },
  mixins: [mediaFormFeatures],
  props: {
    id: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      notEmptyRule: [(val: any) => (val || '').length > 0 || 'This field is required'],
    };
  },
};
